import { DashboardTile } from "components/Dashboard/DashboardTile";

import { useWasteOverviewState } from "../WasteOverviewContext";
import { VendorChart } from "./Charts/VendorChart";

export function VendorTile() {
  const {
    overviewState: { isPending },
  } = useWasteOverviewState();

  return (
    <DashboardTile size={{ xs: 12, md: 6, lg: 6, xl: 5 }} sx={{ opacity: isPending ? 0.5 : 1 }}>
      <DashboardTile.Header
        title="Vendor"
        infoTooltip="Shows waste totals across facilities per waste vendor (entity your
    organization has contracted with to manage waste). Totals are calculated
    from vendor line items, but if no vendor data is present, we will use
    e‑Manifest data."
      />
      <DashboardTile.ContentArea>
        <VendorChart />
      </DashboardTile.ContentArea>
    </DashboardTile>
  );
}
